export const EMERGENCY_ALERT_CSS_CLASS = 'alert-container-div';
export const WEATHER_ALERT_CSS_CLASS = 'weather-alert-container-div';

export function numOfActiveAlerts(): number {
    const selectors = [EMERGENCY_ALERT_CSS_CLASS, WEATHER_ALERT_CSS_CLASS]
        .map((s) => `.${s}`)
        .join(',');
    return document.querySelectorAll(selectors).length;
}
